export default {
    // apiUrl: process.env.REACT_APP_ENV === 'local' ? process.env.REACT_APP_API_URL_LOCAL : process.env.REACT_APP_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD
    apiUrl: process.env.REACT_APP_API,
    appEnv: process.env.REACT_APP_ENV 
}

